import { cloneDeep, isArray, merge, mergeWith } from "lodash";
import {
  createContext,
  FC,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import { DeepPartial } from "react-hook-form";
import { VerificationDTO } from "../../../../../store/verification/models/dto/due-diligence";
import { ConfigContext } from "../common/config-context";

type FinaliseData = DeepPartial<VerificationDTO.Requests.DueDiligence.Form.Post.Final.T>;

export type FormState = {
  data: FinaliseData;
  setData: (d: FinaliseData) => void;
};

export const FormState = createContext<FormState>(
  (undefined as any) as FormState
);

export const FormStateProvider: FC<{}> = ({ children }) => {
  const {
    state: { kycToFillIn },
  } = useContext(ConfigContext);

  const [finaliseData, setFinaliseData] = useState<FinaliseData>({
    kycRequests: Array(kycToFillIn).fill({}),
  });

  const setData = useCallback(
    (d: FinaliseData) =>
      setFinaliseData((curr) => {
        const result = {};
        mergeWith(result, curr, d, (_: any, srcValue: any) => {
          // Make sure that if we have an array (e.g. social media links), any subtraction is accounted for
          if (isArray(srcValue)) {
            return srcValue;
          }
        });
        return result;
      }),
    [setFinaliseData]
  );

  useEffect(() => {
    setData({ kycRequests: Array(kycToFillIn).fill({}) });
  }, [setData, kycToFillIn]);

  return (
    <FormState.Provider
      value={{
        data: finaliseData,
        setData,
      }}
    >
      {children}
    </FormState.Provider>
  );
};
